import React from 'react';
import PropTypes from 'prop-types';
import s from './Timeline.scss';

class Timeline extends React.Component {
  constructor() {
    super();
    this.state = {
      loadmore: false,
    };
  }

  showMoreData = () => {
    this.setState({ loadmore: true });
  };

  render() {
    const { items, title } = this.props;
    let itemSet1 = [];
    let itemSet2 = [];
    itemSet1 = items.slice(0, 2);
    if (items.length > 2) {
      itemSet2 = items.slice(2, items.length);
    }
    return (
      <div className={`${s.timeline}`}>
        <div className={`${s.timelinebody}`}>
          <div className={`${s.timelinesyn}`}>
            <h3 className={`${s.timelinetitle}`}>
              {title && title.length ? title[0].value : ''}
            </h3>
          </div>
          <ol>
            {itemSet1 &&
              itemSet1.length > 0 &&
              itemSet1.map((value, index) => (
                <li className={`${s.clearfix}`} key={index}>
                  <strong>{value.title}</strong>
                  <div className={s.timelinetext}>
                    {value.value &&
                      value.value.length &&
                      value.value.map((data, index1) => (
                        <React.Fragment key={index1}>
                          {this.props.getComponents(data, this.props.isWapView)}
                        </React.Fragment>
                      ))}
                  </div>
                </li>
              ))}
          </ol>
          {itemSet2 &&
            itemSet2.length > 0 && (
              <>
                <div
                  className={`${s.loadmore} ${
                    !this.state.loadmore ? s.show : s.hide
                  }`}
                  onClick={() => {
                    this.showMoreData();
                  }}
                >
                  Read More
                </div>
                <ol className={this.state.loadmore ? s.show : s.hide}>
                  {itemSet2.map((value, index) => (
                    <li className={`${s.clearfix}`} key={index}>
                      <strong>{value.title}</strong>
                      <div className={s.timelinetext}>
                        {value.value &&
                          value.value.length &&
                          value.value.map((data, index1) => (
                            <React.Fragment key={index1}>
                              {this.props.getComponents(data)}
                            </React.Fragment>
                          ))}
                      </div>
                    </li>
                  ))}
                </ol>
              </>
            )}
        </div>
      </div>
    );
  }
}

Timeline.propTypes = {
  title: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  getComponents: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isWapView: PropTypes.bool,
};

Timeline.defaultProps = {
  isWapView: false,
};

export default Timeline;
